import React, { useEffect } from 'react';
import TopNavigation from './TopNavigation';
import ClueRaiderBanner from './components/ClueRaiderBanner';
import { updatePageSEO } from './utils/seo';

const Cookies: React.FC = () => {
  useEffect(() => {
    updatePageSEO(
      'Cookie Policy - Dimension Flux',
      'Cookie policy for Dimension Flux. Learn about the essential and analytics cookies we use, and how to manage your cookie preferences.'
    );
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      <TopNavigation />
      <ClueRaiderBanner />

      <div className="max-w-4xl mx-auto p-4 sm:p-6">
        <div className="bg-white bg-opacity-95 rounded-lg p-6 sm:p-8 border-2 border-gray-300 shadow-lg">
          <h1 className="text-2xl sm:text-3xl font-oswald font-bold text-gray-900 mb-6">Cookie Policy</h1>
          
          <div className="prose prose-gray max-w-none">
            <p className="text-gray-700 font-lora mb-4">
              <strong>Last updated:</strong> September 4, 2025
            </p>
            
            <h2 className="text-xl font-oswald font-bold text-gray-900 mt-6 mb-3">What Are Cookies?</h2>
            <p className="text-gray-700 font-lora mb-4">
              Cookies are small text files that are stored on your device when you visit our website. They help us provide you with a better experience.
            </p>
            
            <h2 className="text-xl font-oswald font-bold text-gray-900 mt-6 mb-3">Types of Cookies We Use</h2>
            
            <h3 className="text-lg font-oswald font-semibold text-gray-900 mt-4 mb-2">Essential Cookies</h3>
            <p className="text-gray-700 font-lora mb-4">
              These cookies are necessary for the website to function properly. They include:
            </p>
            <ul className="list-disc list-inside text-gray-700 font-lora mb-4 space-y-2">
              <li>Game progress and statistics (stored locally)</li>
              <li>User preferences and settings</li>
            </ul>
            
            <h3 className="text-lg font-oswald font-semibold text-gray-900 mt-4 mb-2">Analytics Cookies</h3>
            <p className="text-gray-700 font-lora mb-4">
              We use Google Analytics to understand how visitors use our site. These cookies help us:
            </p>
            <ul className="list-disc list-inside text-gray-700 font-lora mb-4 space-y-2">
              <li>Count visitors and page views</li>
              <li>Understand which pages are most popular</li>
              <li>Identify technical issues</li>
              <li>Improve the overall user experience</li>
            </ul>
            
            <h2 className="text-xl font-oswald font-bold text-gray-900 mt-6 mb-3">Managing Cookies</h2>
            <p className="text-gray-700 font-lora mb-4">
              You can control cookies through:
            </p>
            <ul className="list-disc list-inside text-gray-700 font-lora mb-4 space-y-2">
              <li>Our cookie consent banner (accept or decline analytics cookies)</li>
              <li>Your browser settings (block all cookies)</li>
              <li>Ad blockers and privacy extensions</li>
            </ul>
            
            <h2 className="text-xl font-oswald font-bold text-gray-900 mt-6 mb-3">Third-Party Cookies</h2>
            <p className="text-gray-700 font-lora mb-4">
              We use Google Analytics, which may set its own cookies. You can learn more about Google's cookie practices in their privacy policy.
            </p>
            
            <h2 className="text-xl font-oswald font-bold text-gray-900 mt-6 mb-3">Contact</h2>
            <p className="text-gray-700 font-lora mb-4">
              If you have questions about our use of cookies, please contact us through our website.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
